import RedemptionChartCardComponent from "./RedemptionChartCard";
import RedemptionSummaryCardComponent from "./RedemptionSummaryCard";
import ShippingDetailsCardComponent from "./ShippingDetailsCard";

const RedemptionChartCard = RedemptionChartCardComponent;
const RedemptionSummaryCard = RedemptionSummaryCardComponent;
const ShippingDetailsCard = ShippingDetailsCardComponent;

export { RedemptionChartCard, RedemptionSummaryCard, ShippingDetailsCard };
